export default {"src":"/_next/static/media/horse-racing.faa3690f.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};